<div data-automation="header_component" class="page-header flex flex-row flex-start">
  <div class="flex-95 flex-column">
    <div class="breadcrumb-container flex-row flex-start" *ngIf="showButtonsAndCrumb">
      <div *ngFor="let crumb of header.breadcrumbTrail" class="breadcrumb-item link">
        <a (click)="navTo(crumb.link)" class="clickable">{{crumb.pageTitle | translate}}</a>
        <i class="fa fa-angle-right"></i>
      </div>
      <div class="breadcrumb-item">
        {{header.breadcrumb | translate}}
      </div>
    </div>
    <div class="flex-row">
      <div>
        <h1 data-automation="page_title" class="icon-position" [ngClass]="(showButtonsAndCrumb)?'page-header-title':'page-header-title-no-breadcrumb'">
          {{ header.pageTitle | translate }} <ukg-icon name="help" class="clickable heading-icon-spacing" *ngIf="header.pageTooltip" (click)="tooltip.present($event.target)"></ukg-icon>
        </h1>
      </div>
    </div>
    <ukg-popover #tooltip>
        <p>{{ header.pageTooltip | translate }}</p>
      </ukg-popover>
  </div>
  <div class="flex-5 headerBtnContainer flex-row flex-end-center" *ngIf="showButtonsAndCrumb">
    <div class="help-button-column flex-column" *ngIf="showBack">
      <div>
        <input type="image"
               title="{{ 'COMMON.BACK_BUTTON_ALT' | translate }}"
               appAssetSrc="assets/ButtonBack.gif" alt="{{ 'COMMON.BACK_BUTTON_ALT' | translate }}"
               (click)="goBack()" style="border-width:0px;">
      </div>
      <div>
        <label class="headerBtnLabel" translate>COMMON.BACK_BUTTON_LABEL</label>
      </div>
    </div>
    <div *ngIf="showBack" class="flex-column">
      <div class="divider-column">&nbsp;</div>
    </div>
    <div class="help-button-column flex-column" >
      <div>
        <input type="image" name="ctl00$btnHelp" id="helpBtn" tabindex="4016"
             title="{{ 'COMMON.HELP_BUTTON_ALT' | translate }}"
             appAssetSrc="assets/ButtonHelp.gif" alt="{{ 'COMMON.HELP_BUTTON_ALT' | translate }}"
             (click)="launchHelp()" style="border-width:0px;">
      </div>
    <div>
      <label class="headerBtnLabel" translate>COMMON.HELP_BUTTON_LABEL</label>
    </div>
  </div>
</div>
